import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { CORPACT_CA_ADMIN_ACTION_BASE_PATH } from '../../../../../../../../../features/corporate-action/ca-admin/action/ca-admin-action-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'corporate-actions-action-list',
        label: 'Corporate Actions',
        to: CORPACT_CA_ADMIN_ACTION_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
